import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _06_DOMESTICATED_ANIMAL_FOOD:Partial<EcosystemServiceModel> ={
  id:'domesticated-animal-food',
  pos:6,
  image: "/images/ecoservices/domesticated_animal_food.jpg",
  code: ["1.1.3.1"],
  unit:'domesticated animal food',
  assetType:'species',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "animals for food",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
